import { Outlet } from "react-router-dom";

export function AdminLayout() {
  return (
    <div className="min-h-dvh bg-slate-50 text-slate-900 dark:bg-slate-950 dark:text-slate-50">
      <Outlet />
    </div>
  );
}
